import axios from "@/api/axiosInstance";
import { SaveCatalogProductRequest, SaveCatalogProductResponse } from "./types";

export const updateCatalogProduct = async (
  id: string,
  payload: SaveCatalogProductRequest,
): Promise<SaveCatalogProductResponse> => {
  const response = await axios.put<SaveCatalogProductResponse>(
    `/api/private/product-catalog/products/${id}`,
    payload,
  );
  return response.data;
};
